<template>
    <div v-if="!loading && hasAccess" class="h-full">
        <top-nav-bar></top-nav-bar>

        <div class="text-md font-bold p-1">
            <span class="block">General insurance information is available here.</span>
            <span class="block">Please, contact local HR if you need more specific information or assistance.</span>
        </div>

        <div v-if="insurances.length > 0">
            <div v-for="(insurances, type) in sortedInsurances">
                <div class="wrap-collabsible">
                    <input :id="type" class="toggle" type="checkbox">
                    <label :for="type" class="lbl-toggle">{{type}}</label>
                    <div class="collapsible-content">
                        <div class="content-inner">
                            <p>{{resource.types[type]}}</p>
                        </div>
                    </div>
                </div>
                <insurance-row :insurances="insurances"></insurance-row>
            </div>
        </div>
        <empty :visible="!insurances.length">
            Currently there are no insurances available.
        </empty>
    </div>
    <div v-else class="h-full flex items-center justify-center pt-8">
        <i class="text-blue fas fa-spinner fa-spin fa-3x"></i>
    </div>
</template>

<script>
    import InteractsWithDates from '@/mixins/InteractsWithDates';
    import CanAccessView from "../../mixins/CanAccessView";
    import InsuranceRow from "./InsuranceRow";
    import { resource } from "../../sources/insurances"
    export default {
        components: {InsuranceRow},
        mixins: [InteractsWithDates, CanAccessView],

        data() {
            return {
                insurances: [],
                loading: true,
                message: '',
                resource: resource
            }
        },

        computed: {
            sortedInsurances(){
                return this.insurances.reduce((objectsByKeyValue, obj) => {
                    const value = obj['type'];
                    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
                    return objectsByKeyValue;
                }, {});
            }
        },

        mounted() {
            this.$store.dispatch('fetchEmployee');

            this.$api().get('insurance')
                .then(({data}) => this.insurances = data.data)
                .catch(({response}) => this.message = response.message)
                .finally(() => this.loading = false);
        },
    }
</script>

<style scoped>
    .wrap-collabsible {
        margin-bottom: 1.2rem 0;
    }

    input[type='checkbox'] {
        display: none;
    }

    .lbl-toggle {
        display: block;
        font-weight: bold;
        font-size: 1.2rem;
        text-transform: uppercase;
        padding: 1rem;
        cursor: pointer;
        border-radius: 7px;
        transition: all 0.25s ease-out;
    }


    .lbl-toggle::after {
        content: ' ';
        display: inline-block;
        border-top: 5px solid transparent;
        border-bottom: 5px solid transparent;
        border-left: 5px solid currentColor;
        vertical-align: middle;
        margin-left: .7rem;
        margin-top: .1rem;
        transform: translateY(-2px);
        transition: transform .2s ease-out;
    }

    .toggle:checked + .lbl-toggle::after {
        transform: rotate(90deg) translateX(-3px);
    }

    .collapsible-content {
        max-height: 0px;
        overflow: hidden;
        transition: max-height .25s ease-in-out;
    }

    .toggle:checked + .lbl-toggle + .collapsible-content {
        max-height: 100vh;
    }

    .toggle:checked + .lbl-toggle {
        border-bottom-right-radius: 0;
        border-bottom-left-radius: 0;
    }

    .collapsible-content .content-inner {
        padding: .2rem 1rem;
    }
</style>
